import { has } from 'lodash-es';

export interface AttachedResources {
  type: string;
  label: string;
  path: string;
  filename: string;
}

export interface AttachedResourcesResponse {
  attachedResources: AttachedResources[];
}

export type MediaAttachedResources = AttachedResources;

export const isAttachedResourcesResponse = (
  value: unknown
): value is AttachedResourcesResponse => {
  return has(value, ['attachedResources']);
};
